import { YOO_KASSA } from '@app/constants/socialIntegrationsTypes';

export const YOO_KASSA_LABEL = 'ЮKassa';

export const PAYMENT_SYSTEMS = [
  {
    label: <span data-testid="cash-payment">{YOO_KASSA_LABEL}</span>,
    value: YOO_KASSA,
    filterName: YOO_KASSA_LABEL,
  },
];
